import { Empty, Spin } from 'antd'
import AntdAvatar from 'components/Avatar'
import Flex from 'components/Flex'
import NoInterview from 'components/Images/NoInterview.png'
import Pagination from 'components/Pagination'
import {
  EmptyWrapper,
  InfoSection,
  InfoText,
  LightText,
  RowNumberDiv,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStylesInterview'
import AbsentIcon from 'components/icons/AbsentIcon'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import EditBodyIcon from 'components/icons/EditBodyIcon'
import HoldtocompareIcon from 'components/icons/HoldtocompareIcon'
import SelectTickIcon from 'components/icons/SelectTickIcon'
import { SubWrapper } from 'modules/Dashboard/Partials/style'
import {
  AlertTextDivNew,
  NoteMessageDivNew,
  StyledEditBox,
  StyledSpaceDiv,
} from 'modules/InterviewerDashboard/Partials/style'
import {
  getDriveScoreDetails,
  getDriveScoreParameterDetails,
} from 'modules/InterviewerDashboard/actions'
import { getCandidateDetails, getPromotion } from 'modules/Roles/actions'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { EmptyElement } from '../../../../../components/UIComponents/CommonStyledDiv'
import CandidateViewDrawer from '../InterviewerTabel/CandidateViewDrawer'
import RolesFilter from './RolesFilter'

const InterviewerTabel = ({
  dashboardData,
  roleTableloading,
  candidateList,
  statusFilter,
  setStatusFilter,
  filterData,
  setFilterData,
  page,
  setPage,
  setSortBy,
  setSearch,
  search,
  selectedID,
  setSelectedID,
  candidateRating,
  setCandidateRating,
  singleRoleData,
  currentSelection,
  currentTimeDetails,
  getCandidateList,
  isAllSelected,
  setIsAllSelected,
  selectedTime,
}) => {
  const params = useParams()
  const [candidateDrawer, setCandidateDrawer] = useState(false)
  const [scoreDetail, setScoreDetail] = useState(null)
  const [parameterDetail, setParameterDetail] = useState(null)
  const [canEditScore, setCanEditScore] = useState(false)
  const dispatch = new useDispatch()

  const UserData = useSelector(state => state?.auth?.userData)
  const UserId = params?.userId ? params?.userId : UserData?._id
  const studentDetailsAPI = async data => {
    setScoreDetail(null)
    setParameterDetail(null)
    const { status } = await dispatch(
      getCandidateDetails({
        studentId: data?.studentInterviewMap?.student?.id,
        // The same student can have a different Tally resume for every role.
        // Supplying the role scopes the student API response to this
        // evaluation's application snapshot instead of the shared profile.
        roleId: singleRoleData?.id,
        setLoading: false,
      })
    )

    await dispatch(getPromotion(data?.studentInterviewMap?.student?.id))
    const isScheduled = [
      'SELECTED',
      'RESCHEDULE_REQUESTED',
      'REJECTED',
      'RESCHEDULE',
      'HELD_TO_COMPARE',
    ]?.includes(data.studentInterviewMap?.HRStatus)
    setCanEditScore(
      !(
        data.studentInterviewMap?.driveRoleCandidateMap?.stage ===
          currentSelection?.interviewRound && !isScheduled
      )
    )

    scoreDetails(data)
    parameterDetails(data)
    if (status >= 200 && status < 300) {
      setCandidateDrawer(true)
    }
  }

  const scoreDetails = async data => {
    let responce = await dispatch(
      getDriveScoreDetails(
        data?.studentInterviewMap?.driveRoleCandidateMap?.driveId,
        data?.studentInterviewMap?.student?.id
      )
    )
    setScoreDetail(responce)
  }

  const parameterDetails = async data => {
    let responce = await dispatch(
      getDriveScoreParameterDetails(data?.studentInterviewMap?.id, UserId)
    )
    setParameterDetail(responce)
  }
  const columns = [
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: true,
      render: (_, data) => {
        let statusText
        let icon = ''
        let top
        switch (data?.status) {
          case 'MOVE_TO_NEXT_ROUND':
            statusText = 'Move to next round'
            icon = <SelectTickIcon />
            top = true
            break
          case 'REJECT':
            statusText = 'Reject'
            icon = <RejectIcon />
            top = true
            break

          case 'ABSENT':
            statusText = 'Absent'
            icon = <AbsentIcon />
            top = true
            break
          case 'HOLD_TO_COMPARE':
            statusText = 'Hold to compare'
            icon = <HoldtocompareIcon />
            top = true
            break
          case 'SCHEDULED':
            statusText = 'Scheduled'
            top = false
            break
          default:
            statusText = 'To be updated'
            top = false
            break
        }

        return (
          <div>
            {icon} &nbsp;&nbsp;
            <span style={{ position: 'relative', top: top ? '-6px' : '0px' }}>
              {statusText}
            </span>
          </div>
        )
      },
    },
    {
      title: 'Name',

      render: (_, data) => (
        <Flex alignVertically>
          <AntdAvatar
            src={data?.studentInterviewMap?.student?.profileUrl}
            IconName={
              data?.studentInterviewMap?.student?.firstName?.split('')[0]
            }
            size={35}
          />
          <InfoSection>
            <RowNumberDiv onClick={() => studentDetailsAPI(data)}>
              {' '}
              {data?.studentInterviewMap?.student?.firstName > 60
                ? data?.studentInterviewMap?.student?.firstName?.substr(0, 60) +
                  '...'
                : data?.studentInterviewMap?.student?.firstName +
                  ' ' +
                  data?.studentInterviewMap?.student?.lastName}
            </RowNumberDiv>
            <LightText>
              {data?.studentInterviewMap?.student?.prefixId}
            </LightText>
          </InfoSection>
        </Flex>
      ),
    },

    {
      title: 'Contact Details',
      dataIndex: 'city',

      render: (_, data) => (
        <Flex alignVertically>
          <InfoSection>
            <InfoText>
              {' '}
              {
                data?.studentInterviewMap?.student?.studentPersonalProfile
                  ?.phoneNumber
              }
            </InfoText>
            <InfoText>
              {
                data?.studentInterviewMap?.student?.studentPersonalProfile
                  ?.primaryEmail
              }
            </InfoText>
          </InfoSection>
        </Flex>
      ),
    },

    {
      title: 'Score',
      dataIndex: 'averageScore',
      sorter: true,
      width: '180px',
      render: (text, item) => (
        <Flex style={{ paddingLeft: '20px' }}>
          <StyledEditBox>
            {Number(item?.averageScore)?.toFixed(2)}
          </StyledEditBox>
          <EmptyElement
            style={{ padding: '6px 10px 0px 20px' }}
            onClick={() => studentDetailsAPI(item)}
          >
            <EditBodyIcon />
          </EmptyElement>
        </Flex>
      ),
    },
  ]

  const onPageChange = value => {
    setPage(value - 1)
  }
  const onSorting = (pagination, filter, sorter) => {
    setSortBy(sorter)
  }
  const rowSelection = {
    selectedRowKeys: selectedID,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedID(selectedRowKeys)
    },
    preserveSelectedRowKeys: true,
    getCheckboxProps: record => {
      const isScheduled =
        record.studentInterviewMap?.driveRoleCandidateMap?.stage !=
          currentSelection?.interviewRound ||
        [
          'SELECTED',
          'RESCHEDULE_REQUESTED',
          'REJECTED',
          'RESCHEDULE',
          'HELD_TO_COMPARE',
        ]?.includes(record.studentInterviewMap?.HRStatus)

      return {
        disabled: isScheduled,
      }
    },
  }

  const handleSelectAllClick = () => {
    setIsAllSelected(true)
  }

  const handleClearAllClick = () => {
    setIsAllSelected(false)
    setSelectedID([])
  }

  return (
    <SubWrapper>
      <RolesFilter
        searchValue={search}
        setSearchValue={setSearch}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        filterData={filterData}
        setFilterData={setFilterData}
        jobsList={candidateList}
        candidateRating={candidateRating}
        setCandidateRating={setCandidateRating}
      />

      {selectedID?.length > 0 && candidateList?.count > 10 && (
        <div
          style={{ display: 'flex', wordSpacing: '2px', paddingTop: '10px' }}
        >
          <div style={{ fontSize: '13px', paddingTop: '10px' }}>
            {!isAllSelected ? (
              <>
                {`Selected `}
                <span style={{ fontWeight: 800 }}>
                  {`${selectedID?.length} ${
                    selectedID?.length > 1 ? 'candidates' : 'candidate'
                  }`}
                </span>
                {` from this page.`}
              </>
            ) : (
              <>
                <span style={{ fontWeight: 800 }}>
                  {`${candidateList?.count}`}
                  {` candidates `}
                </span>
                {`from all pages.`}
              </>
            )}
          </div>
          <NoteMessageDivNew mandatory={true}>
            <StyledSpaceDiv mandatory={true}>
              <AlertTextDivNew mandatory={true}>
                {!isAllSelected ? (
                  <span>
                    <EmptyElement
                      style={{
                        paddingLeft: '3px',
                        paddingRight: '3px',
                        wordSpacing: '2px',
                        cursor: 'pointer',
                      }}
                      onClick={handleSelectAllClick}
                    >
                      {`Select all `}
                      <span style={{ fontWeight: 800 }}>
                        {`${candidateList?.count} ${
                          candidateList?.count > 1 ? 'candidates' : 'candidate'
                        }`}
                      </span>
                      {` from all pages.`}
                    </EmptyElement>
                  </span>
                ) : (
                  <span>
                    <EmptyElement
                      style={{
                        fontWeight: '800',
                        paddingLeft: '3px',
                        paddingRight: '3px',
                        wordSpacing: '2px',
                        cursor: 'pointer',
                      }}
                      onClick={handleClearAllClick}
                    >
                      {`Clear Selection`}
                    </EmptyElement>
                  </span>
                )}
              </AlertTextDivNew>
            </StyledSpaceDiv>
          </NoteMessageDivNew>
        </div>
      )}

      <StyledTable
        headerColor={true}
        paddingLeft={true}
        rowSelection={rowSelection}
        onChange={onSorting}
        rowKey={record => record?.studentInterviewMap?.studentId}
        bordered
        columns={columns}
        pagination={false}
        dataSource={candidateList?.result}
        loading={roleTableloading}
        locale={{
          emptyText: (
            <EmptyWrapper center isSpin={!roleTableloading}>
              {roleTableloading ? (
                <Spin />
              ) : (
                <Empty
                  image={NoInterview}
                  imageStyle={{ height: 360 }}
                  description={
                    <span>
                      Relax!<br></br>
                      No interviews was scheduled!
                    </span>
                  }
                />
              )}
            </EmptyWrapper>
          ),
        }}
      />
      <Pagination
        onChange={onPageChange}
        totalPages={candidateList?.totalPage * 10}
        pageSize={10}
        current={page + 1}
      />

      {candidateDrawer && (
        <CandidateViewDrawer
          candidateDrawer={candidateDrawer}
          setCandidateDrawer={setCandidateDrawer}
          scoreDetail={scoreDetail}
          singleRoleData={singleRoleData}
          currentSelection={currentSelection}
          currentTimeDetails={currentTimeDetails}
          getCandidateList={getCandidateList}
          setScoreDetail={setScoreDetail}
          canEditScore={canEditScore}
          parameterDetail={parameterDetail}
          selectedTime={selectedTime}
        />
      )}
    </SubWrapper>
  )
}

export default InterviewerTabel
